'use client';

import { memo } from 'react';
import SymfonyRouter from '@services/symfony';

// Symfony Router (CLIENT COMPONENT)
// ************************************************************************************
export const SymfonyRouterClient = memo(({ locale } : { locale: Locale; }) => {
  SymfonyRouter.setLocale(locale);

  return null;
});
